import { CommonRoute } from '@common/models/route'
import NotFound from '@common/views/NotFound.vue'

export const notFoundRoute = {
  path: '/:pathMatch(.*)',
  name: CommonRoute.NOT_FOUND,
  component: NotFound,
}
